import {useState} from "react";
import {FiPlus} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {ButtonVariant} from "@/components/button/Button.types.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {EditContactModalAction} from "@/pages/contacts/list/actions/EditContactModalAction.tsx";

export const CreateContactAction = ({variant}: {variant?: ButtonVariant} = {}) => {
  const [show, setShow] = useState(false);
  const formId = "form-contact-new";
  return (
    <>
      <Button size={"large"} variant={variant} onClick={() => setShow(true)}>
        <Icon icon={FiPlus} /> Create Contact
      </Button>
      <EditContactModalAction formId={formId} show={show} setShow={setShow} />
    </>
  );
};
